import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {
  hd: boolean = true;
  sprink: boolean = true;
  spy: boolean = true;
  irrigatio: boolean = true;
  constructor() { }

  ngOnInit(): void {
  }

  all() {
    this.hd = true;
    this.sprink = true;
    this.spy = true;
    this.irrigatio = true;
  }

  hdpepipe() {
    this.hd = true;
    this.sprink = false;
    this.spy = false;
    this.irrigatio = false;
  }

  sprinkle() {
    this.hd = false;
    this.sprink = true;
    this.spy = false;
    this.irrigatio = false;
  }

  spary() {
    this.hd = false;
    this.sprink = false;
    this.spy = true;
    this.irrigatio = false;
  }

  irrigation() {
    this.hd = false;
    this.sprink = false;
    this.spy = false;
    this.irrigatio = true;
  }

}
